/* eslint-disable no-unused-vars */
export enum PaymentReturnPathEnum {
   SUCCESS = '/payment-success',
   FAILED = '/payment-failed'
}
